import {ModuleComponent} from "../../js/module-component";

/**
 * Hero "Agentes IA" tipo 2 (SEION).
 *  - Mensajes de actividad rotativos en cada tarjeta de agente (data-messages).
 *  - Rotación de métricas de prueba social (data-proofs).
 *  - Parallax sutil de la red en escritorio (puntero).
 *  Los textos vienen del Twig (traducibles). Respeta prefers-reduced-motion.
 */
export class ModAgentsTwo extends ModuleComponent{

    ready(){
        super.ready();

        this.el = this.$root.get(0);
        if(!this.el) return;

        this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        this.timers = [];

        this.startCardMessages();
        this.startProofRotation();
        this.startParallax();
    }

    // -- Mensajes rotativos por tarjeta --------------------------------------
    startCardMessages(){
        if(this.reduceMotion) return;
        const cards = this.el.querySelectorAll(".web-mod-agents-two__card");
        cards.forEach((card, cardIndex) => {
            const output = card.querySelector(".js-card-activity");
            const messages = (card.dataset.messages || "").split("|").filter(Boolean);
            if(!output || messages.length < 2) return;
            let index = 0;
            const timer = setInterval(() => {
                output.classList.add("is-changing");
                setTimeout(() => {
                    index = (index + 1) % messages.length;
                    output.textContent = messages[index];
                    output.classList.remove("is-changing");
                }, 240);
            }, 3300 + cardIndex * 440);
            this.timers.push(timer);
        });
    }

    // -- Rotación de la prueba social ----------------------------------------
    startProofRotation(){
        if(this.reduceMotion) return;
        const proof = this.el.querySelector(".js-proof-text");
        const container = this.el.querySelector(".web-mod-agents-two__proof");
        if(!proof || !container) return;
        const proofs = (container.dataset.proofs || "").split("|").filter(Boolean);
        if(proofs.length < 2) return;
        let i = 0;
        const timer = setInterval(() => {
            proof.classList.add("is-changing");
            setTimeout(() => {
                i = (i + 1) % proofs.length;
                proof.textContent = proofs[i];
                proof.classList.remove("is-changing");
            }, 280);
        }, 4200);
        this.timers.push(timer);
    }

    // -- Parallax sutil (escritorio) -----------------------------------------
    startParallax(){
        if(this.reduceMotion || !window.matchMedia("(pointer:fine)").matches) return;
        const network = this.el.querySelector(".js-network");
        if(!network) return;
        const layers = network.querySelectorAll("[data-parallax]");

        this.onMove = (event) => {
            const rect = network.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width - .5) * 2;
            const y = ((event.clientY - rect.top) / rect.height - .5) * 2;
            layers.forEach(el => {
                const depth = Number(el.dataset.parallax || .2);
                el.style.translate = `${(x * 10 * depth).toFixed(2)}px ${(y * 9 * depth).toFixed(2)}px`;
            });
        };
        this.onLeave = () => layers.forEach(el => { el.style.translate = "0 0"; });

        network.addEventListener("pointermove", this.onMove, {passive: true});
        network.addEventListener("pointerleave", this.onLeave, {passive: true});
        this.network = network;
    }

    destroy(){
        this.timers.forEach(t => clearInterval(t));
        if(this.network){
            this.network.removeEventListener("pointermove", this.onMove);
            this.network.removeEventListener("pointerleave", this.onLeave);
        }
        if(super.destroy) super.destroy();
    }
}
